import React, {useEffect, useRef, useState} from 'react';
import {Link, useHistory} from "react-router-dom";
import {withRouter} from 'react-router';
import {getAPI} from "../APIUtil";
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import AppNav from "./AppNav";
import {Card, Col, Container, Form, InputGroup, Row} from "react-bootstrap";
import {addField, useDebounce} from "../CMUtil";
import MdDatatable, {InitialLoading, sortCaret} from "../MdDataTable";
import AsyncSelect from "react-select/async";
import Button from "react-bootstrap/Button";

export const UserList = () => {

  const history = useHistory();
  const iniSearch = useRef(true);

  const [loadingCss, setLoadingCss] = useState("loading_panel_init");

  const [loading, setLoading] = useState(true);
  const [locPage, setLocPage] = useState(null);
  const [locSizePerPage, setLocSizePerPage] = useState(null);
  const [locTotalSize, setLocTotalSize] = useState(null);
  const [locSortField, setLocSortField] = useState(null);
  const [locSortOrder, setLocSortOrder] = useState(null);

  const [keyword, setKeyword] = useState("");
  const debouncedKeyword = useDebounce(keyword, 500, setLocPage);
  const [deptId, setDeptId] = useState("");
  const debounceDeptId = useDebounce(deptId, 500, setLocPage);
  const [permissionId, setPermissionId] = useState("");
  const debouncePermissionId = useDebounce(permissionId, 500, setLocPage);

  const [deptIdSelected, setDeptIdSelected] = useState(null);
  // const [deptIdList, setDeptIdList] = useState([]);
  const [permissionIdSelected, setPermissionIdSelected] = useState(null);
  // const [permissionIdList, setPermissionIdList] = useState([]);

  const [listData, setListData] = useState([]);

  // 項目定義
  const columns = [
    {
      dataField: 'user_id',
      text: '社員番号',
      classes: 'tbl-col link',
      sort: true,
      headerStyle: {width: '80px'},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        <div><a onClick={() => onClickLinkToDetail(row.user_id)}>{cell}</a></div>
      )
    },
    {
      dataField: 'name',
      text: '名前',
      classes: 'tbl-col',
      sort: true,
      headerStyle: {width: '150px'},
      formatter: (cell, row) => (
        <span>{row.name}</span>
      )
    },
    {
      dataField: 'dept',
      text: '部署',
      classes: 'tbl-col',
      sort: true,
      headerStyle: {width: '150px'},
    },
    {
      dataField: 'permission',
      text: '権限',
      classes: 'tbl-col',
      sort: true,
      headerStyle: {width: '150px'},
    },
    {
      dataField: 'email',
      text: 'メール',
      classes: 'tbl-col',
      sort: true,
      headerStyle: {width: '150px'},
    },
  ];

  // 初期化
  useEffect(() => {
    const init = async () => {
      if (!history.location.state) {
        setLocPage(1);
      } else if (!history.location.state.pages) {
        setLocPage(1);
      } else if (!history.location.state.pages.filters) {
        setLocPage(1);
      } else if (Object.keys(history.location.state.pages.filters).length === 0) {
        setLocPage(1);
      } else {
        setLocPage(history.location.state.pages.page);
        setLocSizePerPage(history.location.state.pages.sizePerPage);
        setLocSortField(history.location.state.pages.sortField);
        setLocSortOrder(history.location.state.pages.sortOrder);
      }
    }
    init();
  }, []);

  // 検索処理
  useEffect(() => {
    if (iniSearch.current) {
      iniSearch.current = false;
      return;
    }
    const update = async () => {
      setLoading(true);
      let condition = {};
      addField(condition, "page", locPage);
      addField(condition, "size_per_page", locSizePerPage);
      addField(condition, "sort_field", locSortField);
      addField(condition, "sort_order", locSortOrder);
      addField(condition, "keyword", keyword);
      addField(condition, "dept_id", deptId);
      addField(condition, "permission_id", permissionId);

      localStorage.setItem("user_search_condition", JSON.stringify(condition)); // 検索条件保持
      const res = await getAPI("ms_user_search_view", condition);
      setListData(res);
      setLoading(false);
      setLoadingCss("loading_panel_fadeout");
    }
    update();
  }, [
    locPage,
    locSizePerPage,
    locSortField,
    locSortOrder,
    debouncedKeyword,
    debounceDeptId,
    debouncePermissionId
  ]);

  const onTableChange = async (type, {page, sizePerPage, filters, sortField, sortOrder, cellEdit}) => {
    if ("pagination" === type) {
      setLocPage(page);
    }
    if ("sizePerPage" === type) {
      setLocSizePerPage(sizePerPage);
    }
    if ("sort" === type) {
      setLocSortField(sortField);
      setLocSortOrder(sortOrder);
    }
  }

  const onClickLinkToDetail = (user_id) => {
    history.push("/user/" + user_id);
  }

  const handleChangeDeptId = (value) => {
    setDeptIdSelected(value ? value : "");
    setDeptId(value ? value.id : "");
  }

  const onSearchDeptId = async (query) => {
    return [
      {id: "営業", name: "営業"},
      {id: "編集", name: "編集"},
      {id: "制作", name: "制作"},
      {id: "経理", name: "経理"},
      {id: "経営", name: "経営"},
      {id: "システム", name: "システム"}
    ];
  }

  const handleChangePermissionId = (value) => {
    setPermissionIdSelected(value ? value : "");
    setPermissionId(value ? value.id : "");
  }

  const onSearchPermissionId = async (query) => {
    return [
      {id: "メンバー", name: "メンバー"},
      {id: "管理者", name: "管理者"}
    ];
  }

  const onClickClear = () => {
    setKeyword("");
    setDeptId("");
    setDeptIdSelected(null);
    setPermissionId("");
    setPermissionIdSelected(null);
  }

  return (
    <>
      <AppNav/>
      <div className="h1">
        <h1>
          社員
        </h1>
      </div>
      <Card className="card-search">
        <Container className="container-main-search">
          <Form.Group as={Row}>
            <Form.Label column sm="1">キーワード</Form.Label>
            <Col sm="2">
              <Form.Control type="text" value={keyword} onChange={e => setKeyword(e.target.value)}/>
            </Col>
            <Col sm="1"></Col>

            <Form.Label column sm="1">部署</Form.Label>
            <Col sm="2">
              <AsyncSelect
                className="async-select"
                cacheOptions
                defaultOptions
                isClearable
                value={deptIdSelected}
                getOptionLabel={e => e.name}
                getOptionValue={e => e.id}
                loadOptions={onSearchDeptId}
                onChange={handleChangeDeptId}
                placeholder=""
              />
            </Col>

            <Form.Label column sm="1"></Form.Label>

            <Form.Label column sm="1">権限</Form.Label>
            <Col sm="2">
              <AsyncSelect
                className="async-select"
                cacheOptions
                defaultOptions
                isClearable
                value={permissionIdSelected}
                getOptionLabel={e => e.name}
                getOptionValue={e => e.id}
                loadOptions={onSearchPermissionId}
                onChange={handleChangePermissionId}
                placeholder=""
              />
            </Col>
            <Col sm="1">
              <Button variant="clear" onClick={e => onClickClear()}>条件クリア</Button>
            </Col>
          </Form.Group>
        </Container>
      </Card>

      <Container className="container-main-list">
        <InitialLoading loadingCss={loadingCss}/>
        <MdDatatable
          keyField="user_id"
          listData={listData}
          columns={columns}
          loading={loading}
          onTableChange={onTableChange}
          page={locPage}
          sizePerPage={locSizePerPage}
          totalSize={locTotalSize}
          sortField={locSortField}
          sortOrder={locSortOrder}
          showPagenation={true}
          linkToAdd="/user/"
        />
      </Container>
    </>
  );
}

export default withRouter(UserList);